/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import StatsBar from '../../../Common/StatsBar';
import Sponsor from '../../../Common/Sponsor';
import { useSponsorValue } from '../../../../context/sponsorContext';
import {
  getStatsBarData,
  createTagList,
  selectImgCrop,
  transformUpsellData,
  deviceManagerUtil,
  createTagArr,
  getContentAccessLocal,
  playHereMedia,
} from '../../../../utils/utils';
import { CONTENT_TYPE, ACCOUNT_SUBSCRIPTION } from '../../../../constants/globalConstants';
import { COLLECTION_MODAL } from '../../../../constants/containerConstants';
import { Video as VidTransform } from '../../../../data-transform/components/Video';
import BrightcoveClass from '../../../../utils/brightcove';
import { continueOnOtherAction, playHereAction } from '../../../../actions/sponsorAction';
import UpSell from '../../../Common/UpSell';

const Video = ({ t, data, stopVideo, index, slick, isMediaPlaying, onSkip = () => {} }) => {
  const Brightcove = useMemo(() => new BrightcoveClass(), []);
  const [portraitClass, setPortraitClass] = useState('');
  const [collectionStyle, setCollectionStyle] = useState({});
  const containerRef = useRef(null);
  const deviceManagerObj = useRef(null);
  const contentAccessFlag = useRef(null);
  const [
    {
      userLoginDetail,
      isLoginChecked,
      deviceSynclimitReached,
      deviceInfo,
      continueOnOther,
      playHere,
    },
    dispatch,
  ] = useSponsorValue();
  const [imgUrlStyle, setImgUrlStyle] = useState({});

  useEffect(() => {
    if (isLoginChecked && userLoginDetail) {
      deviceManagerObj.current = {
        UID: userLoginDetail && userLoginDetail.UID,
        deviceID: localStorage.getItem('deviceID'),
        dispatch: dispatch,
        deviceName: t('MUTVWebPlayer'),
      };
    }
  }, [userLoginDetail, isLoginChecked]);

  const setContentAccessState = (videoData) => {
    const ContentAccess = videoData && videoData.ContentAccess && videoData.ContentAccess.value;
    const ContentType = videoData && videoData.ContentType && videoData.ContentType.value;
    const manutds = videoData && videoData.manutds;
    const tags = !ContentAccess && createTagArr(manutds);
    return getContentAccessLocal(ContentAccess, ContentType, tags);
  };

  useEffect(() => {
    setCollectionVideoContainer();
    const transformData = VidTransform(data, true);
    contentAccessFlag.current =
      transformData && transformData.fields && setContentAccessState(transformData.fields);
    const options = {
      muted: false,
      loop: false,
      controlBar: {
        volumePanel: {},
        pictureInPictureToggle: false,
      },
      autoplay: !stopVideo,
    };

    Brightcove.brightCoveWebPlayer(
      'coll-' + data.mediaid_s,
      data.itemid_s,
      'collectionVideo',
      transformData.fields,
      options,
      function (playerObj) {
        playerObj && playerObjActions(playerObj);
        deviceManagerFunc(playerObj);
        // playerObj.on('loadedmetadata', function (evt) {
        //   const getcurrentSlide = slick && slick.querySelector('.slick-current');
        //   if (getcurrentSlide) {
        //     const currentIndex = getcurrentSlide.getAttribute('data-index');
        //     (currentIndex !== index || (stopVideo && currentIndex === index)) &&
        //       Brightcove.pauseVideo(true);
        //   }
        // });
        // playerObj.on('ads-pod-started', function (evt) {
        //   const getcurrentSlide = slick && slick.querySelector('.slick-current');
        //   if (getcurrentSlide) {
        //     const currentIndex = getcurrentSlide.getAttribute('data-index');
        //     (currentIndex !== index || (stopVideo && currentIndex === index)) &&
        //       Brightcove.pauseVideo(true);
        //   }
        // });
      }
    );

    return () => {
      Brightcove.closeVideo();
    };
  }, [Brightcove, containerRef]);

  useEffect(() => {
    if (continueOnOther && Brightcove) {
      continueOnOtherAction(dispatch, false);
      onSkip();
      Brightcove.pauseVideo();
    }
  }, [continueOnOther]);
  useEffect(() => {
    playHereMedia(playHere, Brightcove, playHereAction, dispatch);
  }, [playHere]);

  useEffect(() => {
    if (
      contentAccessFlag &&
      contentAccessFlag.current === ACCOUNT_SUBSCRIPTION &&
      deviceManagerObj &&
      deviceManagerObj.current
    ) {
      const { deviceId } = deviceManagerObj.current;
      const deviceCheck = deviceSynclimitReached && deviceInfo.deviceId != deviceId;
      deviceCheck && Brightcove.pauseVideo();
    }
  }, [deviceSynclimitReached, deviceInfo]);

  const playerObjActions = (playerObj) => {
    playerObj.on('playing', () => {
      if (contentAccessFlag.current === ACCOUNT_SUBSCRIPTION) {
        const mediaObj = {
          status: true,
          userDetail: deviceManagerObj && deviceManagerObj.current,
        };
        isMediaPlaying(mediaObj);
      }
    });
  };
  const deviceManagerFunc = (playerObj) => {
    const actionObj = { deviceObj: deviceManagerObj.current, actionObj: playerObj };
    deviceManagerUtil(actionObj);
  };

  const setCollectionVideoContainer = () => {
    // $('.ad-block').addClass('ADFIXED');
    const wH = window.innerHeight;
    const wW = window.innerWidth;
    const vD = data.celummetadatadetails_s && data.celummetadatadetails_s.dimension;
    const videoProperties = {};
    if (vD) {
      let splittedVal = vD.split('x');
      let vH = +splittedVal[1];
      let vW = +splittedVal[0];
      if (vH > vW) {
        setPortraitClass('portrait-bcVideo');
        let cW = containerRef.current.clientWidth;
        let cH = containerRef.current.clientHeight;
        if (vH > vW && wH < 728) {
          // remove close button margin
          cH = wH - 30;
        }
        const ratio = vH / vW;
        if (vW > cW && vH <= cH) {
          vW = (vH / vW) * vW;
          videoProperties['width'] = vW;
          videoProperties['height'] = vH;
        } else if (vW < cW && vH >= cH) {
          vW = (cH / vH) * vW;
          vH = cH;
          videoProperties['width'] = vW;
          videoProperties['height'] = vH;
        } else if (cW < vW && cH < vH) {
          vW = (cH / vH) * vW;
          vH = cH;
          if (ratio === 1 && wW <= 768) {
            vW = wW;
            vH = vW;
          }
          videoProperties['width'] = vW;
          videoProperties['height'] = vH;
        } else {
          videoProperties['width'] = vW;
          videoProperties['height'] = vH;
        }
        setCollectionStyle({ maxWidth: `${videoProperties.width}px` });
        setCropImg(videoProperties.width, videoProperties.height);
      } else {
        let cW = containerRef.current.clientWidth;
        let cH = containerRef.current.clientHeight;
        setCropImg(cW, cH);
      }
    }
  };

  const setCropImg = (width, height) => {
    if (data.imagecropurl_s) {
      const crop = selectImgCrop(
        width,
        height,
        data.imagecropurl_s,
        false,
        data.iswebpavailablebool_b
      );
      crop && setImgUrlStyle({ backgroundImage: `url(${crop})`, opacity: 1 });
    }
  };

  return (
    <React.Fragment>
      <Sponsor
        contentType={data.contenttype_t}
        varient={data.variant_t}
        sponsorInfo={data.sponsordetailinfo_s}
        grid={'grid-12'}
        type={CONTENT_TYPE}
        author={data.authorname_s}
        cardName={data.shortheadline_t}
        container={COLLECTION_MODAL}
        createdDateTime={data.appearance_tdt || data.__published_tdt}
        itemId={data.itemid_s}
        tags={createTagList(data.taglist_sm, data.category_s)}
      ></Sponsor>
      <div
        ref={containerRef}
        className={`grid-8 ratio centeritem collection-video ${portraitClass}`}
        style={collectionStyle}
      >
        <div className="mu-content home-article-detail__video-panel">
          <article className="mu-item video brightcove-web-video centeritem">
            <div className="img-holder">
              <figure style={imgUrlStyle}>
                <div className="mu-item__video video_play">
                  <div
                    className="mu-item__player video-element"
                    id={'coll-' + data.mediaid_s}
                    style={{ opacity: 1 }}
                  ></div>
                </div>
              </figure>
            </div>
          </article>
        </div>
      </div>
      <div className="mu-modal__body__description">
        <p className="mu-item__teasure" tabIndex="0">
          {data.shortheadline_t}
          <span className="screenreader">{data.contenttype_t}</span>
        </p>
        {data.upsell_s && <UpSell data={transformUpsellData(data.upsell_s)} />}
      </div>
      <StatsBar
        item={getStatsBarData(data)}
        upSellData={data.upsell_s && transformUpsellData(data.upsell_s)}
      />
    </React.Fragment>
  );
};

export default withTranslation()(Video);
